import { emptyStateVariants } from '~/components/component-library/EmptyState/styles'
import { type EmptyStateProps } from '~/components/component-library/EmptyState/types'
import { cn } from '~/utils/tailwind-utils'

export { type EmptyStateProps } from '~/components/component-library/EmptyState/types'

export const EmptyState = ({
  children,
  icon,
  title,
  textSize,
  fullScreen = false,
  className = '',
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        'flex flex-col justify-center rounded-lg bg-gray-50 text-primary dark:bg-gray-900',
        { 'w-full bg-white dark:bg-black': fullScreen },
        className,
      )}
    >
      <div
        className={
          'mx-auto flex w-full max-w-md flex-col items-center space-y-2 p-8 text-center [&>svg]:mb-4'
        }
      >
        {icon && icon}
        {title && <h2 className="text-center text-lg">{title}</h2>}

        <div
          className={cn(
            'space-y-4 text-balance text-center text-secondary',
            emptyStateVariants({ textSize }),
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
